import React from 'react';
import { Row, Col, Card, Spinner } from 'react-bootstrap';

const BannerStats = ({ stats, loading }) => {
  if (loading) {
    return (
      <Card className="mb-4">
        <Card.Body className="text-center py-4">
          <Spinner animation="border" variant="primary" size="sm" className="me-2" />
          Carregando estatísticas...
        </Card.Body>
      </Card>
    );
  }

  if (!stats) {
    return null;
  }

  const {
    total_banners = 0,
    active_banners = 0,
    total_views = 0,
    total_clicks = 0,
    averageCTRFormatted = '0.00%',
    activePercentage = 0,
    top_performing_banners = []
  } = stats;

  return (
    <Row className="mb-4">
      {/* Total de Banners */}
      <Col lg={3} md={6} className="mb-3">
        <Card className="stat-card border-0 shadow-sm h-100">
          <Card.Body className="text-center">
            <div className="stat-icon bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
              <i className="las la-image text-primary" style={{ fontSize: '1.5rem' }} />
            </div>
            <h3 className="stat-number text-primary mb-1">{total_banners}</h3>
            <p className="stat-label text-muted mb-0">Total de Banners</p>
          </Card.Body>
        </Card>
      </Col>

      {/* Banners Ativos */}
      <Col lg={3} md={6} className="mb-3">
        <Card className="stat-card border-0 shadow-sm h-100">
          <Card.Body className="text-center">
            <div className="stat-icon bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
              <i className="las la-check-circle text-success" style={{ fontSize: '1.5rem' }} />
            </div>
            <h3 className="stat-number text-success mb-1">{active_banners}</h3>
            <p className="stat-label text-muted mb-0">
              Ativos ({activePercentage}%)
            </p>
          </Card.Body>
        </Card>
      </Col>

      {/* Total de Visualizações */}
      <Col lg={3} md={6} className="mb-3">
        <Card className="stat-card border-0 shadow-sm h-100">
          <Card.Body className="text-center">
            <div className="stat-icon bg-info bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
              <i className="las la-eye text-info" style={{ fontSize: '1.5rem' }} />
            </div>
            <h3 className="stat-number text-info mb-1">
              {total_views.toLocaleString('pt-BR')}
            </h3>
            <p className="stat-label text-muted mb-0">Visualizações</p>
          </Card.Body>
        </Card>
      </Col>

      {/* Total de Cliques */}
      <Col lg={3} md={6} className="mb-3">
        <Card className="stat-card border-0 shadow-sm h-100">
          <Card.Body className="text-center">
            <div className="stat-icon bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
              <i className="las la-mouse-pointer text-warning" style={{ fontSize: '1.5rem' }} />
            </div>
            <h3 className="stat-number text-warning mb-1">
              {total_clicks.toLocaleString('pt-BR')}
            </h3>
            <p className="stat-label text-muted mb-0">
              Cliques (CTR: {averageCTRFormatted})
            </p>
          </Card.Body>
        </Card>
      </Col>

      {/* Top Performing Banners */}
      {top_performing_banners && top_performing_banners.length > 0 && (
        <Col xs={12} className="mt-2">
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-transparent border-0 pb-0">
              <h6 className="mb-0">
                <i className="las la-chart-line text-success me-2" />
                Top 3 Banners com Melhor Performance
              </h6>
            </Card.Header>
            <Card.Body className="pt-2">
              <Row>
                {top_performing_banners.slice(0, 3).map((banner, index) => (
                  <Col lg={4} md={6} key={banner.id} className="mb-2">
                    <div className="d-flex align-items-center p-2 rounded border">
                      <div className="flex-shrink-0 me-3">
                        <div className={`badge ${
                          index === 0 ? 'bg-warning' : 
                          index === 1 ? 'bg-secondary' : 'bg-info'
                        } rounded-pill`}>
                          #{index + 1}
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1 small fw-bold text-truncate">
                          {banner.title}
                        </h6>
                        <div className="small text-muted">
                          <span className="me-2">
                            <i className="las la-eye me-1" />
                            {banner.view_count?.toLocaleString('pt-BR') || 0}
                          </span>
                          <span className="me-2">
                            <i className="las la-mouse-pointer me-1" />
                            {banner.click_count?.toLocaleString('pt-BR') || 0}
                          </span>
                          <span className="text-success fw-bold">
                            CTR: {banner.click_through_rate || 0}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      )}
    </Row>
  );
};

export default BannerStats;